<template>
    <div :class="frontSelectedApp ? 'app_selected' : ''" :style="frontSelectedApp ? 'background-color: ' + frontSelectedAppData.header_bgcolor : ''
        ">
        <div class="container">
            <div class="row-fluid">
                <div class="header-main">
                    <div class="navMenu float-left float-none w-auto">
                        <router-link :to="`/app/` + frontSelectedApp" class="d-flex align-items-center">
                            <img v-bind:src="frontSelectedAppAvatar" class="rounded" />
                            <span class="ml-3 h5 ml-0 mb-0">{{ frontSelectedAppData.name }}</span>
                        </router-link>
                    </div>
                    <div class="right-box">
                        <div class="goto float-right dropdown-right" v-if="frontSelectedAppLangs.length > 1">
                            <select name="sel_lang" id="sel_lang" class="form-control" v-model="frontSelectedAppLang"
                                @change="funcChangeLang">
                                <option v-for="SelectedAppLang in frontSelectedAppLangs" :value="SelectedAppLang.lang_key">
                                    {{ siteLanguages[SelectedAppLang.lang_key].name }}
                                </option>
                            </select>
                        </div>
                        <div class="goto float-right">
                            <!-- <a href="/" class="float-right">
                                <i class="fa fa-external-link-alt"></i> Go to Home
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row-fluid">
                <div class="sare" v-if="frontSelectedApp">
                    <div class="search-group">
                        <form role="form" v-on:submit.prevent="searchTerm">
                            <input type="text" class="search" ref="search" v-model="term"
                                placeholder="Search for answers..." />
                            <span class="fa fa-search searchicon"></span>
                            <span v-if="term" @click="clearTerm" class="fa fa-times clearicon"></span>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const favicon = document.querySelector("link[rel='icon']");
export default {
    name: "Header",
    data() {
        return {
            term: "",
            frontSiteApps: {},
            frontSelectedApp: "",
            frontSelectedAppLang: "en",
            frontSelectedAppLangs: {},
            frontSelectedAppAvatar: "",
            frontSelectedAppData: {},
        };
    },
    created() {
        this.$store.dispatch("getSiteLanguages");
        if (typeof this.$route.params.lang !== "undefined") {
            this.frontSelectedAppLang = this.$route.params.lang;
        } else if (localStorage.frontSelectedAppLang) {
            this.frontSelectedAppLang = localStorage.frontSelectedAppLang;
        }
        localStorage.setItem("frontSelectedApp", this.frontSelectedAppLang);
        this.frontsideapps();
    },
    mounted() {
        if (localStorage.frontSelectedAppLang) {
            this.frontSelectedAppLang = localStorage.getItem("frontSelectedAppLang");
        }
    },
    methods: {
        clearTerm() {
            this.term = "";
            this.$refs.search.focus();
        },
        searchTerm: function () {
            this.$router.push(
                "/app/" +
                this.frontSelectedApp +
                "/search/" +
                this.term +
                "/" +
                this.frontSelectedAppLang
            );
        },
        frontsideapps() {
            axios.get(`/api/siteApps`).then((response) => {
                const fsapp = response.data.apps;
                this.frontSiteApps = fsapp;
                if (typeof this.$route.params.app_slug !== "undefined") {
                    const find_app_langs = this.frontSiteApps.find(
                        (item) => item.slug == this.$route.params.app_slug
                    );
                    this.frontSelectedAppLangs = find_app_langs.app_langs;
                    this.frontSelectedApp = this.$route.params.app_slug;
                    this.frontSelectedAppAvatar = find_app_langs.avatar;
                    this.frontSelectedAppData = find_app_langs;
                    localStorage.setItem("frontSelectedApp", this.frontSelectedApp);
                    favicon.setAttribute("href", this.frontSelectedAppAvatar);

                    if (typeof this.$route.params.lang !== "undefined") {
                        this.frontSelectedAppLang = this.$route.params.lang;
                    }
                }
            });
        },
        funcChangeLang() {
            var _tmp_url = "/app";
            var route_name = this.$router.currentRoute.name;
            $.each(this.$router.currentRoute.params, function (key, value) {
                if (key != "lang") {
                    _tmp_url += "/" + value;
                }
                if (key == "app_slug") {
                    if (typeof route_name != "undefined") {
                        _tmp_url += "/" + route_name;
                    }
                }
            });
            _tmp_url = _tmp_url + "/" + this.frontSelectedAppLang;
            localStorage.setItem("frontSelectedAppLang", this.frontSelectedAppLang);
            this.$emit("changeSiteLangVar", this.frontSelectedAppLang);
            //this.$router.push("/app/" + this.frontSelectedApp );
            this.$router.push(_tmp_url);
        },
    },
    computed: {
        siteLanguages() {
            return this.$store.getters.siteLanguages;
        },
    },
};
</script>

<style>
.header {
    padding: 0;
}
</style>
